/* eslint-disable react-refresh/only-export-components */
import { useState } from 'react'
import { Button, Text, TextInput } from '@mantine/core'
import { modals } from '@mantine/modals'

// Any org member can delete a board (PD-1899), so the confirm is deliberately
// hard: the word has to be typed out — pasting it is blocked.
const CONFIRM_WORD = 'Delete'

const DeleteBoardForm = ({ name, onConfirm }: { name: string; onConfirm: () => void }) => {
  const [value, setValue] = useState('')
  const matches = value.trim().toLowerCase() === CONFIRM_WORD.toLowerCase()
  const blockPaste = (e: { preventDefault: () => void }) => e.preventDefault()

  const submit = () => {
    if (!matches) return
    onConfirm()
    modals.closeAll()
  }

  return (
    <div>
      <Text size="sm">
        Move “{name}” to Trash? Its tasks are kept. A super admin can restore it, or permanently
        delete it.
      </Text>
      <TextInput
        mt="sm"
        data-autofocus
        label={`Type "${CONFIRM_WORD}" to confirm`}
        placeholder={CONFIRM_WORD}
        autoComplete="off"
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
        onPaste={blockPaste}
        onDrop={blockPaste}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit()
        }}
      />
      <div className="mt-3 flex justify-end gap-2">
        <Button variant="default" size="xs" onClick={() => modals.closeAll()}>
          Cancel
        </Button>
        <Button color="red" size="xs" disabled={!matches} onClick={submit}>
          Delete board
        </Button>
      </div>
    </div>
  )
}

export const openDeleteBoardModal = (opts: { name: string; onConfirm: () => void }) => {
  modals.open({
    title: 'Delete board',
    children: <DeleteBoardForm name={opts.name} onConfirm={opts.onConfirm} />,
  })
}
